// extracted by mini-css-extract-plugin
module.exports = {"logosContainer":"logo-slider_logosContainer__d2WYz","slide":"logo-slider_slide__XaNde","logo":"logo-slider_logo__eqgbk"};